import React, { memo } from 'react'
import moment from 'moment-timezone'
import { Grid } from 'transfix-ui/core'
import { RoutingGuideRowProps } from 'apps/marketplace/apiTypes/carrierRoutingGuides'
import { pickupTimeSummary, deliveryTimeSummary } from 'apps/marketplace/utils/helpers/rates'
import { FORMATS } from 'constants/datetime'

export const RoutingGuidesRowDetails = memo<RoutingGuideRowProps>(
  ({
    deliveryTimePreference,
    dispatcher,
    expirationDate,
    isOnlyBeer,
    isOnlyDropTrailer,
    isShipperExclusive,
    pickupTimePreferences,
    shipper,
    startDate,
  }) => {
    return (
      <Grid container spacing={2}>
        <Grid item md={5}>
          <div className='text-secondary'>Shipper:</div>
          {shipper ? (
            <>
              {isShipperExclusive ? 'Only' : 'Prefers'}
              &nbsp;
              <a href={`/shippers/${shipper.id}`} target='_blank' rel='noopener noreferrer'>
                {shipper.name}
              </a>
            </>
          ) : (
            'Any'
          )}
        </Grid>
        <Grid item md={7}>
          <div className='text-secondary'>Dispatcher:</div>
          <a
            href={`${__ROOT__}/users/${dispatcher.parentUserId}`}
            target='_blank'
            rel='noopener noreferrer'>
            {dispatcher.firstName} {dispatcher.lastName}
          </a>
        </Grid>
        <Grid item md={5}>
          <div className='text-secondary'>Start Date:</div>
          {startDate ? moment.utc(startDate).format(FORMATS.dateFormat) : 'ASAP'}
        </Grid>
        <Grid item md={7}>
          <div className='text-secondary'>Loading Type:</div>
          {isOnlyDropTrailer ? 'Prefers Drop Trailer' : 'Live Load'}
        </Grid>
        <Grid item md={5}>
          <div className='text-secondary'>Expiration Date:</div>
          {expirationDate ? moment.utc(expirationDate).format(FORMATS.dateFormat) : 'Never'}
        </Grid>
        <Grid item md={7}>
          <div className='text-secondary'>Pickup Time:</div>
          {pickupTimeSummary(pickupTimePreferences)}
        </Grid>
        <Grid item md={5}>
          <div className='text-secondary'>Commodity Type:</div>
          {isOnlyBeer ? 'Only Beer' : 'Any'}
        </Grid>
        <Grid item md={7}>
          <div className='text-secondary'>Delivery Time:</div>
          {deliveryTimeSummary(deliveryTimePreference)}
        </Grid>
      </Grid>
    )
  }
)
